module.exports = __webpack_public_path__ + "static/img/sznj.2afe025b.png";